import { render, staticRenderFns } from "./homeTopTwo.vue?vue&type=template&id=2effa89d&scoped=true"
import script from "./homeTopTwo.vue?vue&type=script&lang=js"
export * from "./homeTopTwo.vue?vue&type=script&lang=js"
import style0 from "./homeTopTwo.vue?vue&type=style&index=0&id=2effa89d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effa89d",
  null
  
)

export default component.exports